export const getStatus = (status: string) => {
    switch (status) {
        case 'created':
            return  'Created';
        case 'done':
            return  'Done';
        case 'cancelled':
            return  'Cancelled';
        case 'not_started':
            return  'Not Started';
        case 'accepted':
            return  'Accepted';
        case 'rejected':
            return  'Rejected';
        case 'requires_manual_check':
            return  'Requires Check';
        case 'not_able_to_calculate':
            return  'Not Able To Calculate';
        case 'failed':
            return  'Failed';

        default:
            return 'Pending';
    }

};

